import React, { useState } from 'react';
import EnhancedApp from './EnhancedApp';
import { Report } from './components/report';
import { GraphDemo } from './components/GraphDemo';
import { FairyFarmDemo } from './components/FairyFarmDemo';

type Tab = 'report' | 'simulator' | 'graph-demo' | 'fairy-farm';

function App() {
  const [activeTab, setActiveTab] = useState<Tab>('report');

  return (
    <div className="min-h-screen bg-white">
      {/* Tab Navigation */}
      <div className="border-b border-gray-300 sticky top-0 z-50 bg-white overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-12 gap-4">
            <h1 className="text-base font-medium text-gray-900">
              2040 Beryl Lane
            </h1>
            <div className="flex border border-gray-300">
              <button
                onClick={() => setActiveTab('report')}
                className={`px-4 py-1.5 text-sm ${activeTab === 'report' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
              >
                Report
              </button>
              <button
                onClick={() => setActiveTab('simulator')}
                className={`px-4 py-1.5 text-sm border-l border-gray-300 ${activeTab === 'simulator' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
              >
                Simulator
              </button>
              <button
                onClick={() => setActiveTab('graph-demo')}
                className={`px-4 py-1.5 text-sm border-l border-gray-300 ${activeTab === 'graph-demo' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
              >
                Graph Demo
              </button>
              <button
                onClick={() => setActiveTab('fairy-farm')}
                className={`px-4 py-1.5 text-sm border-l border-gray-300 ${activeTab === 'fairy-farm' ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
              >
                Fairy Farm
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'report' && <Report />}
      {activeTab === 'simulator' && <EnhancedApp />}
      {activeTab === 'graph-demo' && <GraphDemo />}
      {activeTab === 'fairy-farm' && <FairyFarmDemo />}
    </div>
  );
}

export default App;
